import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import DOMPurify from 'dompurify'
import { useData } from "../contexts/DataContext";
import NotFoundPage from '../pages/NotFoundPage'
import SkeletonPage from '../pages/SkeletonPage'


function DynamicContent() {
  const { category, subcategory } = useParams();
  const { fetchContent } = useData();
  const [content, setContent] = useState(null);
  const [mainContent, setMainContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [subCollections, setSubCollections] = useState([]);

  useEffect(() => {
    async function loadContent() {
      try {
        setLoading(true);
        const result = await fetchContent(category, subcategory);
        
        if (subcategory) {
          setContent(result.content);
          setMainContent(result.mainContent);
        } else {
          setContent(result.content);
          if (result.subCollections) {
            setSubCollections(result.subCollections);
          }
        }
      } catch (error) {
        console.error("Error loading content:", error);
      } finally {
        setLoading(false);
      }
    }
    
    loadContent();
  }, [category, subcategory, fetchContent]);

  useEffect(() => {
    if (!loading && content) {
      let title;
      
      if (subcategory && mainContent) {
        title = `${mainContent.title} - ${content.title}`;
      } else if (content) {
        title = content.title;
      } else {
        title = '성별정정툴킷';
      }
      
      document.title = title;
    }
    
    // Optional: Set a loading title
    if (loading) {
      document.title = '로딩 중... - 성별정정툴킷';
    }
    
    // Cleanup: Reset to default title when component unmounts
    return () => {
      document.title = '성별정정툴킷';
    };
  }, [loading, content, mainContent, subcategory]);

  // 외부 링크 처리 함수
const updateExternalLinks = () => {
  const links = document.querySelectorAll('a[href]');
  
  links.forEach(link => {
    const href = link.getAttribute('href');
    
    // 내부 링크 조건들
    const isInternal = href.startsWith('/') || 
                      href.startsWith('#') || 
                      href.includes('gender-toolkit.kr');
    
    // 내부 링크가 아니면 새창으로 열기
    if (!isInternal) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });
 };
 
 // 콘텐츠가 변경될 때마다 외부 링크 처리
 useEffect(() => {
  if (!loading && content) {
    // DOM 업데이트를 위해 약간의 지연
    setTimeout(updateExternalLinks, 100);
    
    // MutationObserver로 동적 변경 감지
    const observer = new MutationObserver(() => {
      setTimeout(updateExternalLinks, 50);
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    return () => observer.disconnect();
  }
 }, [loading, content, mainContent]); // content와 mainContent가 변경될 때마다 실행

  if (loading) return <SkeletonPage />;
  if (!content) return <NotFoundPage />;

  return (
    <div className="content_wrapper">
      <div className="title_area">
        <div className="title_content">
          <div className="breadcrumb">
            <Link to='/'>홈</Link><span>/</span>
            {
              subcategory ? 
                            <><Link to={`/${category}`} className="maincategory_btn">{mainContent.title}</Link>
                            </>
                          : 
                            <p>{content.title}</p> 
            }
            
          </div>
          <h2>{content.title}</h2>
          <div className="subtitle" dangerouslySetInnerHTML={{__html: content.subtitle}} />
        </div>
      </div>
      <div className="content">
        {
          !subcategory ? (
              <ul className="subcontents">
                <li className="desc">
                  <div  className="subtitle" 
                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content.content)}} />
                </li>
                {subCollections.map((subcoll, k) => (
                  <li key={k}>
                    <Link to={`/${category}/${subcoll.id}`}>
                      <p>{subcoll.title}</p>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" className="primary"/><path className="secondary" d="M10.3 8.7a1 1 0 0 1 1.4-1.4l4 4a1 1 0 0 1 0 1.4l-4 4a1 1 0 0 1-1.4-1.4l3.29-3.3-3.3-3.3z"/></svg>
                    </Link>
                  </li>
                ))}
              </ul>
            ) 
          :
              <div  className="maincontent"
                    dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content.content)}} />
        }
      </div>
    </div>
  );
}

export default DynamicContent